const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assessment Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {assessments} assessments the resource defined to manage assessments
 */
app.directive('questionPresenter', ['AssessmentLib', function (AssessmentLib) {
  return {
    restrict: 'E',
    scope: {
      question: '=',
      userResponses: '=',
      onResponse: '&'
    },
    template: require('../../../templates/directives/assessments/question-presenter.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.helpers = {
        stopProp: function(evt) {
          evt.stopPropagation();
        },
        shuffleArray: function (array) {
          for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
          }
        },
        sortByProp: function (arr, prop) {
          arr.sort(function(a, b) {
            if (a[prop] > b[prop]) {
              return 1;
            }
            if (a[prop] < b[prop]) {
              return -1;
            }
            return 0;
          });
        },
      };

      self.choices = {
        options: [],
        settings: {
          multiple_selections: false,
          randomize_choice_order: false,
          manual_grade: false,
          manual_points: false,
          number_of_selections: 1
        },
        selections: {},
        singleSelection: '',
        inputs: [],
        select: function(id) {
          if ($scope.question.format && self.choices.selectionOptions[$scope.question.format]) {
            self.choices.selectionOptions[$scope.question.format](id);
            return;
          }
          console.log('invalid question format or no selection option set for format');
        },
        selectionOptions: {
          multiple_choice: function(id) {
            var currentSelections = [];
            var allowedSelections = 1;

            self.choices.selections[id] = !self.choices.selections[id];
            if (self.choices.selections[id]) {
              currentSelections.push(id);
            }

            if (self.choices.settings.multiple_selections && self.choices.settings.number_of_selections) {
              allowedSelections = parseInt(self.choices.settings.number_of_selections);
            }

            for (var key in self.choices.selections) {
              if (key === id) {
                continue;
              }

              if (self.choices.settings.multiple_selections) {
                if (self.choices.selections[key] && currentSelections.length < allowedSelections) {
                  currentSelections.push(key);
                  continue;
                }
                self.choices.selections[key] = false;
                continue;
              }

              self.choices.selections[key] = false;
            }

            self.updateSelections();
          }
        },
        parse: function() {
          self.choices.settings = AssessmentLib.helpers.getQuestionOptions($scope.question);

          if (self.choices.settings.manual_grade) {
            self.setWatch();
            return;
          }

          var newChoices = $scope.question.choice_options && $scope.question.choice_options ? $scope.question.choice_options.slice(0) : [];
          self.helpers.sortByProp(newChoices, 'position');
          self.choices.options = newChoices;

          if (self.choices.settings.randomize_choice_order) {
            self.helpers.shuffleArray(newChoices);
            self.choices.options = newChoices;
          }

          self.choices.options.forEach(function(item) {
            item.value = item.id;
            item.name = item.copy;
          });

          if ($scope.userResponses) {
            self.parseResponses();
          }

          self.setWatch();
        },
        checkInputEnter: function(keyPress) {
          if (!self.choices.settings.multiple_selections || !self.choices.settings.number_of_selections || self.choices.settings.number_of_selections < 2) {
            return;
          }

          if (keyPress !== 'click' && keyPress.which !== 13) {
            return;
          }
          if (!self.choices.singleSelection) {
            return;
          }
          self.choices.inputs.push(self.choices.singleSelection);
          self.choices.singleSelection = '';
          if (self.choices.inputs.length > self.choices.settings.number_of_selections) {
            self.choices.inputs.shift();
          }
          self.updateSelections()
        },
        removeInput: function(index) {
          self.choices.inputs.splice(index, 1);
          self.updateSelections()
        },
        checkWords: function() {
          var count = 0;
          self.choices.overMax = false;
          self.choices.overMin = false;
          if (self.choices.singleSelection && typeof self.choices.singleSelection === 'string') {
            count = self.choices.singleSelection.split(' ').length;
          }
          if (count > self.choices.settings.word_limit) {
            self.choices.overMax = true;
            return;
          }
          if (count < self.choices.settings.word_minimum) {
            self.choices.overMin = true;
            return;
          }
        }
      };

      self.updateSelections = function() {
        var items = null;

        if ($scope.question.format === 'multiple_choice') {
          items = [];
          for (var key in self.choices.selections) {
            if (self.choices.selections[key] && items.indexOf(key) === -1) {
              items.push(key);
            }
          }
        }
        if ($scope.question.format === 'dropdown') {
          items = [self.choices.singleSelection];
        }
        if ($scope.question.format === 'long_input') {
          self.choices.overMax = false;
          if (self.choices.settings.word_limit && self.choices.singleSelection && typeof self.choices.singleSelection === 'string') {
            self.choices.wordCount = self.choices.singleSelection.split(' ').length;
            if (self.choices.wordCount > self.choices.settings.word_limit) {
              self.choices.overMax = true;
            }
          }
          items = [self.choices.singleSelection];
        }
        if ($scope.question.format === 'short_input') {
          if (!self.choices.settings.multiple_selections || !self.choices.settings.number_of_selections || self.choices.settings.number_of_selections < 2) {
            items = [self.choices.singleSelection];
          } else {
            items = self.choices.inputs.slice(0);
          }
        }
        if (items) {
          $scope.userResponses[$scope.question.id] = items;
          $scope.onResponse();
        }

      };

      self.setWatch = function() {
        if ($scope.question.format === 'multiple_choice') {
          return;
        }
        if ($scope.question.format === 'short_input' && self.choices.settings.multiple_selections && self.choices.settings.number_of_selections && self.choices.settings.number_of_selections > 1) {
          return;
        }
        var updateDelay = null;
        $scope.$watch('presenter.choices.singleSelection', function(newVal, oldVal) {
          if (!newVal && !oldVal) {
            return;
          }
          if (updateDelay) {
            window.clearTimeout(updateDelay);
          }
          updateDelay = setTimeout(self.updateSelections, 600);
          return;
        });
      };

      self.parseResponses = function() {
        if (!$scope.question || !$scope.userResponses || !$scope.userResponses[$scope.question.id] || !$scope.userResponses[$scope.question.id].length) {
          return;
        }

        if ($scope.question.format === 'multiple_choice') {
          self.choices.selections = {};
          $scope.userResponses[$scope.question.id].forEach(function(id) {
            self.choices.selections[id] = true;
          });
        }

        if ($scope.question.format === 'dropdown' || $scope.question.format === 'long_input') {
          self.choices.singleSelection = $scope.userResponses[$scope.question.id][0];
        }

        if ($scope.question.format === 'short_input') {
          if (!self.choices.settings.multiple_selections || !self.choices.settings.number_of_selections || self.choices.settings.number_of_selections < 2) {
            self.choices.singleSelection = $scope.userResponses[$scope.question.id][0];
          } else {
            self.choices.inputs = [];
            $scope.userResponses[$scope.question.id].forEach(function(item) {
              self.choices.inputs.push(item);
            });
          }
        }

      };

      if (!$scope.question || (!$scope.question.choice_options && $scope.question.format !== 'short_input')) {
        var optionWatch = $scope.$watch('question', function(newVal, oldVal) {
          self.choices.parse();
        });
        return;
      }

      self.choices.parse();

      var responseWatch = $scope.$watch('userResponses', function(newVal) {
        if (newVal) {
          self.parseResponses();
          responseWatch();
        }
      }, true);
    }],
    controllerAs: 'presenter'
  };
}]);